module.exports = __webpack_public_path__ + "static/media/wa-background-dark.fd9e5955.png";